import React from 'react'
import { makeStyles } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 16
  }
}))

const PatientsListError = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  return <div className={classes.root}>{t('general.genericError')}</div>
}

export default PatientsListError
